import { render, staticRenderFns } from "./FeatureColumns.vue?vue&type=template&id=3d63abc4&"
import script from "./FeatureColumns.vue?vue&type=script&lang=js&"
export * from "./FeatureColumns.vue?vue&type=script&lang=js&"
import style0 from "./FeatureColumns.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports